<!-- Toolbar Info Panel with slide animation -->
<div class="toolbar-info-panel mat-elevation-z1" >
  <mat-card class="info-card" appearance="outlined">
    <mat-card-content>
      <div class="panel-container">
        <!-- Left section with icon and content -->
        <div class="content">
          <div class="info-section">
            <mat-icon class="info-icon" [color]="'primary'">{{ icon }}</mat-icon>
            <div class="info-text">
              <h4 class="info-title">{{ title }}</h4>
              <p class="info-description">{{ description }}</p>
            </div>
          </div>
        </div>

        <!-- Right section with actions -->
        <div class="actions">
          <button matIconButton color="accent" (click)="closePanel()" matTooltip="Close panel" aria-label="Close information panel">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
